module.exports = __webpack_public_path__ + "whimstay-logo.png?b8d7a7e549a01f8533df64ab7d5cf2f2";